import { Component } from 'react';
import { NSARouterMakerProps } from 'namirasoft-account-react';
import { NWSRegionRouterProps } from '../NWSRegionRouterProps';
import { NWSRegionLayout } from '../NWSRegionLayout';
import { NWSRegionEntities } from '../NWSRegionEntities';

export interface RegionViewPageProps extends NSARouterMakerProps, NWSRegionRouterProps { }

class RegionViewPage extends Component<RegionViewPageProps>
{
    override render()
    {
        return (
            <NWSRegionLayout
                {...this.props}
                pages={{
                    entity: NWSRegionEntities.region(this.props),
                    view: {}
                }}
            >
                <></>
            </NWSRegionLayout>
        );
    }
}

export default RegionViewPage;